import PropTypes from 'prop-types';
import {
    EditProps,
    RaRecord,
    ShowButton,
    TitlePortal,
    TopToolbar,
    useEditContext,
    useResourceDefinition,
} from 'react-admin';
import { ReactNode } from 'react';
import BackButton from '../../common/BackButton';
import { mergeSx } from '../../../utils/material-ui';
import { SxProps } from '@mui/system';
import { Stack } from '@mui/material'; // import Typography from "@mui/material/Typography";
// import Typography from "@mui/material/Typography";

export const EditActions = ({
    className,
    title,
    extraActions,
    sx,
    ...rest
}: EditActionsProps & {
    title?: EditProps['title'];
    extraActions?: ReactNode;
    sx?: SxProps;
}) => {
    const { record } = useEditContext();
    const { hasShow } = useResourceDefinition(rest);

    return (
        <TopToolbar
            className={className}
            {...sanitizeRestProps(rest as any)}
            sx={[
                (theme) => ({
                    justifyContent: 'flex-start',
                    pt: 0,
                    pb: 0,
                    mb: 2,
                    minHeight: 'auto',
                    flexWrap: 'wrap',
                    [theme.breakpoints.down('md')]: {
                        background: 'none',
                    },
                }),
                ...mergeSx(sx),
            ]}
        >
            <BackButton type={'icon'} />

            <TitlePortal variant={'h2'} whiteSpace={'break-spaces'} />

            <Stack
                flexDirection={'row'}
                justifyContent={'flex-end'}
                gap={1}
                flexWrap={'wrap-reverse'}
                sx={{
                    width: {
                        xs: '100%',
                        md: 'auto'
                    }
                }}
            >
                {extraActions}

                {hasShow && <ShowButton record={record} />}
            </Stack>
        </TopToolbar>
    );
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const sanitizeRestProps = ({
    hasCreate = null,
    hasEdit = null,
    hasShow = null,
    hasList = null,
    ...rest
}) => rest;

/* eslint-enable @typescript-eslint/no-unused-vars */

export interface EditActionsProps {
    className?: string;
    data?: RaRecord;
    hasCreate?: boolean;
    hasEdit?: boolean;
    hasList?: boolean;
    hasShow?: boolean;
    resource?: string;
}

EditActions.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    hasCreate: PropTypes.bool,
    hasEdit: PropTypes.bool,
    hasShow: PropTypes.bool,
    hasList: PropTypes.bool,
    resource: PropTypes.string,
};
